import { postLead } from 'entities/lead/api';
import { FormData, toCreateDto } from './form';

export async function createNewLead(formData: FormData) {
  const dto = toCreateDto(formData);
  return postLead(dto);
}